












































// Vue
import { Component, Vue, Watch } from 'vue-property-decorator'

// models
import { OtherConfigForm, OtherConfigModel } from '@/models/config'

// services
import { OtherConfigService } from '@/services/config'

// utils
import { alerts } from '@/utils'

// componnents
import { Input } from '@/components/form'
import { PageHeader, Loading } from '@/components'

@Component({
	name: 'OtherConfigIndex',
	components: {
		PageHeader,
		Input,
		Loading
	}
})
export default class OtherConfigIndex extends Vue {
	title = ''
	loading = false
	items = [
		{
			text: 'Dashboard'
		},
		{
			text: 'Otras Configuraciones',
			active: true
		}
	]

	selected!: OtherConfigModel
	config: OtherConfigForm = {
		value: 0
	}

	created () {
		this.getConfig()
	}

	async getConfig () {
		this.loading = true
		const idConfig = Number(this.$route.params.id)
		const config = await OtherConfigService.getByID(idConfig)
		this.selected = config
		this.config.value = config.value
		this.title = config.name
		if (idConfig === 2) {
			this.title = `${this.title} (%)`
		}
		this.loading = false
	}

	async save () {
		this.loading = true
		try {
			await OtherConfigService.update(Number(this.$route.params.id), this.config)
			alerts.success()
		} catch (e) {
			alerts.error()
		}
		this.loading = false
	}

	@Watch('$route', { immediate: true, deep: true })
  changeRoute () {
    this.getConfig()
  }
}
